import type { Screen } from './types.tsx';

export const PROCESSING_SCREENS: Screen[] = ['plan_generating', 'coding_task', 're_coding_task'];

export const CODE_CONTENT_SCREENS: Screen[] = [
	'coding_task',
	're_coding_task',
	'code_generation_success',
];

export const AUTODEV_MODAL_QUERYPARAM_KEY = 'showAutodev';
export const ROVO_CHAT_QUERYPARAM_KEY = 'openConversation';

export const ADDITIONAL_LINES_CHUNK_SIZE = 10;

export const Interactions = {
	AGENT_RUN_AUTODEV_BUTTON: 'autodev-agent-picker.run-autodev-button',
	AGENT_RESTART_JOB_BUTTON: 'autodev-agent-picker.restart-job-button',
	AUTODEV_BUTTON: 'autodev.button',
	GENERATE_PLAN: 'autodev.generate-plan',
	RETRY_GENERATE_PLAN: 'autodev.retry-generate-plan',
	RETRY_GENERATE_CODE: 'autodev.retry-generate-code',
	GENERATE_CODE: 'autodev.generate-code',
	DISCARD_PLAN: 'autodev.discard-plan',
	STOP_CODE_GEN: 'autodev.discard-plan',
	DELETE_JOB: 'autodev.delete-job',
	MAKE_CODE_CHANGE: 'autodev.make-code-change',
	REGENERATE_PLAN: 'autodev.regenerate-plan',
	DELETE_PLAN_STEP: 'autodev.delete-plan-step',
	UPDATE_PLAN_STEP: 'autodev.update-plan-step',
	DISCARD_JOB: 'autodev.discard-plan',
	ADD_PLAN_STEP: 'autodev.add-plan-step',
	ADD_PLAN_STEP_TASK: 'autodev.add-plan-step-task',
	UPDATE_PLAN_STEP_TASK: 'autodev.update-plan-step-task',
	DELETE_PLAN_STEP_TASK: 'autodev.delete-plan-step-task',
	RE_RUN_JOB: 'autodev.re-run-job',
} as const;
